import { createPortal } from 'react-dom';
import clsx from 'clsx';
import { Icon } from '@/components/Icon';
import { useDragStore } from './store';
import css from './dnd.module.css';

/**
 * What the pointer is carrying: a translucent copy of every icon in the drag,
 * each keeping the offset it had from the cursor when it was picked up — so
 * five icons dragged off the desktop stay in the arrangement you grabbed them
 * in, which is what makes the drop land where the ghosts say it will.
 *
 * Mounted once by the desktop, portalled to `document.body`, and above
 * everything a drag can pass over.
 */
export function DragLayer() {
  const drag = useDragStore();

  if (!drag.active || typeof document === 'undefined') return null;

  return createPortal(
    <div className={css.layer} aria-hidden="true">
      {drag.ghosts.map((ghost) => (
        <div
          key={ghost.path}
          className={clsx(css.ghost, ghost.inline && css.ghostInline)}
          style={{ left: drag.x + ghost.dx, top: drag.y + ghost.dy, width: ghost.w }}
        >
          <Icon src={ghost.icon} size={ghost.iconSize} />
          <span className={css.ghostLabel}>{ghost.label}</span>
        </div>
      ))}
    </div>,
    document.body,
  );
}
